import React, { useEffect, useState, useCallback } from "react";
import { Container, Row, Col, Table, Button } from "react-bootstrap";
import { FiSearch, FiEdit2, FiPlus } from "react-icons/fi";
import {
  createDesignation,
  getAllDesignations,
  updateDesignation,
  getAllDepartments,
} from "../../../api/onboarddeboard";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BRAND = "#2E5CB8";

const LEVEL_COLORS = {
  Senior:  { bg: "#e8e0ff", color: "#6633cc" },
  Mid:     { bg: "#e0f0ff", color: "#0066cc" },
  Junior:  { bg: "#e0f8ff", color: "#0099aa" },
  Intern:  { bg: "#fff0e0", color: "#cc6600" },
  Lead:    { bg: "#fff8d0", color: "#997700" },
  Manager: { bg: "#ffe0e8", color: "#cc0044" },
};

const LEVELS = ["Junior", "Mid", "Senior", "Lead", "Intern", "Manager"];

const STYLE = `
  @media (max-width: 767px) {
    .desg-col-dept, .desg-col-count, .desg-col-status { display: none !important; }
    .desg-table td, .desg-table th { padding: 10px 10px !important; }
  }
  @media (max-width: 575px) {
    .desg-col-level { display: none !important; }
  }
`;

const GrayInput = ({ placeholder, value, onChange, autoFocus }) => (
  <input
    type="text"
    placeholder={placeholder}
    value={value}
    onChange={onChange}
    autoFocus={autoFocus}
    style={{
      width: "100%", height: 46, padding: "0 14px",
      background: "#f3f4f6", border: "none", borderRadius: 8,
      fontSize: 14, color: "#374151", outline: "none",
      fontFamily: "inherit", boxSizing: "border-box",
    }}
    onFocus={(e) => e.target.style.background = "#ebebed"}
    onBlur={(e)  => e.target.style.background = "#f3f4f6"}
  />
);

const GraySelect = ({ value, onChange, children }) => (
  <div style={{ position: "relative" }}>
    <select
      value={value}
      onChange={onChange}
      style={{
        width: "100%", height: 46, padding: "0 40px 0 14px",
        background: "#f3f4f6", border: "none", borderRadius: 8,
        fontSize: 14, color: value ? "#374151" : "#9ca3af",
        outline: "none", fontFamily: "inherit",
        appearance: "none", WebkitAppearance: "none",
        cursor: "pointer", boxSizing: "border-box",
      }}
    >
      {children}
    </select>
    <svg
      width="16" height="16" viewBox="0 0 24 24" fill="none"
      style={{ position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}
    >
      <path d="M9 18l6-6-6-6" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </div>
);

const Designation = () => {
  const token = localStorage.getItem("token");

  const [designations, setDesignations] = useState([]);
  const [departments,  setDepartments]  = useState([]);
  const [searchText,   setSearchText]   = useState("");
  const [showModal,    setShowModal]    = useState(false);
  const [editId,       setEditId]       = useState(null);
  const [submitting,   setSubmitting]   = useState(false);

  const [designationName, setDesignationName] = useState("");
  const [departmentId,    setDepartmentId]    = useState("");
  const [level,           setLevel]           = useState("");
  const [status,          setStatus]          = useState("Active");
  const [nameError,       setNameError]       = useState("");
    const [isQaFlag,        setIsQaFlag]        = useState(false);


  const fetchDesignations = useCallback(async () => {
    try {
      const res = await getAllDesignations(token);
      if (res.status === 200) setDesignations(res.data);
    } catch (err) { console.error(err); }
  }, [token]);

  const fetchDepartments = useCallback(async () => {
    try {
      const res = await getAllDepartments(token);
      if (res.status === 200) setDepartments(res.data);
    } catch (err) { console.error(err); }
  }, [token]);

  useEffect(() => {
    fetchDesignations();
    fetchDepartments();
  }, [fetchDesignations, fetchDepartments]);

  const resetForm = () => {
    setDesignationName(""); setDepartmentId("");
    setLevel(""); setStatus("Active"); setNameError("");
    setIsQaFlag(false);
  };

  const handleOpenAdd = () => { setEditId(null); resetForm(); setShowModal(true); };

  const handleEdit = (d) => {
    setEditId(d.id);
    setDesignationName(d.designationName || "");
    setDepartmentId(d.departmentId ? String(d.departmentId) : "");
    setLevel(d.level || "");
    setStatus(d.status || "Active");
    setIsQaFlag(d.isQaFlag || false);
    setNameError("");
    setShowModal(true);
  };

  const handleClose = () => {
    if (submitting) return;
    setShowModal(false); resetForm(); setEditId(null);
  };

  const validateName = (v) => {
    const t = v.trim();
    if (!t)                         return "Designation Name is required";
    if (/^[0-9]+$/.test(t))         return "Cannot be numbers only";
    if (/^[^a-zA-Z0-9]+$/.test(t)) return "Cannot contain only special characters";
    if (!/^(?=.*[A-Za-z0-9])[\s\S]+$/.test(t)) return "Invalid designation name";
    return "";
  };

  const handleNameChange = (e) => {
    const val = e.target.value;
    setDesignationName(val);
    setNameError(val === "" ? "" : validateName(val));
  };

  const handleSubmit = async () => {
  if (submitting) return;
  const err = validateName(designationName);
  if (err) { setNameError(err); return; }

  const currentName = designationName.trim().toLowerCase();
  const isDuplicate = designations.some(
    (d) =>
      d.id !== editId &&
      d.designationName.trim().toLowerCase() === currentName
  );

  if (!editId && isDuplicate) {
    toast.warn("Designation with this name already exists");
    return;
  }

  if (editId) {
    const ex = designations.find((d) => d.id === editId);
   if (
  ex &&
  ex.designationName.trim() === designationName.trim() &&
  String(ex.departmentId ?? "") === departmentId &&
  (ex.level || "") === level &&
  (ex.status || "Active") === status &&
  (ex.isQaFlag ?? false) === isQaFlag
) { toast.warn("No changes found for updation"); return; }
  }

  const payload = {
    designationName: designationName.trim(),
    level:           level || null,
    status,
    departmentId:    departmentId ? parseInt(departmentId) : null,
    isQaFlag:        isQaFlag,
  };

  setSubmitting(true);
  try {
    if (editId) {
      await updateDesignation(editId, payload, token);
      toast.success("Designation updated successfully");
    } else {
      await createDesignation(payload, token);
      toast.success("Designation created successfully");
    }
    handleClose();
    fetchDesignations();
  } catch {
    toast.error("Something went wrong");
  } finally {
    setSubmitting(false);
  }
};

  const filtered = designations.filter((d) =>
    d.designationName.toLowerCase().includes(searchText.toLowerCase())
  );

  const lvlStyle = (lvl) => LEVEL_COLORS[lvl] || { bg: "#f0f0f0", color: "#555" };

  const getDeptName = (d) => {
    if (d.departmentName) return d.departmentName;
    if (d.departmentId) {
      const found = departments.find((dep) => dep.id === d.departmentId);
      return found ? found.departmentName : "—";
    }
    return "—";
  };

  return (
    <Container fluid className="p-3 p-md-4">
      <style>{STYLE}</style>

      <Row className="align-items-center mb-3 g-2">
        <Col xs={12} sm={8} md={9}>
          <h5 className="page-main-heading">Designations</h5>
          <small className="page-sub-heading">Manage job roles and hierarchy within departments</small>
        </Col>
        <Col xs={12} sm={4} md={3} className="d-flex justify-content-sm-end">
          <Button
            variant="primary"
            onClick={handleOpenAdd}
            style={{ borderRadius: 8, fontWeight: 500, background: BRAND, borderColor: BRAND }}
          >
            <FiPlus className="me-1" /> Add Designation
          </Button>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col xs={12} md={5} lg={4}>
          <div style={{ position: "relative" }}>
            <FiSearch
              color="#9ca3af" size={15}
              style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}
            />
            <input
              type="text"
              placeholder="Search designations..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{
                width: "100%", height: 38,
                padding: "0 14px 0 36px",
                border: "1px solid #e2e8f0",
                borderRadius: 8, fontSize: 13,
                color: "#374151", background: "#fff",
                outline: "none", boxSizing: "border-box",
                fontFamily: "inherit",
              }}
              onFocus={(e) => e.target.style.borderColor = "#93c5fd"}
              onBlur={(e)  => e.target.style.borderColor = "#e2e8f0"}
            />
          </div>
        </Col>
      </Row>

      <div style={{ background: "#fff", borderRadius: 10, boxShadow: "0 1px 4px rgba(0,0,0,0.07)", overflow: "hidden" }}>
        <Table hover responsive className="mb-0 align-middle desg-table">
          <thead>
            <tr style={{ background: "#f8f9fa", borderBottom: "2px solid #e9ecef" }}>
              <th style={TH}>Designation Name</th>
              <th style={TH} className="desg-col-dept">Department</th>
              <th style={{ ...TH, textAlign: "center" }} className="desg-col-level">Level</th>
              <th style={{ ...TH, textAlign: "center" }} className="desg-col-count">Employee Count</th>
              <th style={{ ...TH, textAlign: "center" }} className="desg-col-status">Status</th>
              <th style={{ ...TH, textAlign: "center" }}>QA Role</th>
              <th style={{ ...TH, textAlign: "center" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center py-5 text-muted">No designations found</td>
              </tr>
            ) : (
              filtered.map((d) => {
                const ls = lvlStyle(d.level);
                return (
                  <tr key={d.id}>
                    <td style={{ padding: "14px 20px", fontWeight: 500 }}>{d.designationName}</td>
                    <td style={{ padding: "14px 20px", color: "#555" }} className="desg-col-dept">{getDeptName(d)}</td>
                    <td style={{ padding: "14px 20px", textAlign: "center" }} className="desg-col-level">
                      {d.level ? (
                        <span style={{ background: ls.bg, color: ls.color, borderRadius: 20, padding: "3px 14px", fontSize: 13, fontWeight: 500 }}>
                          {d.level}
                        </span>
                      ) : "—"}
                    </td>
                    <td style={{ padding: "14px 20px", textAlign: "center" }} className="desg-col-count">{d.employeeCount ?? 0}</td>
                    <td style={{ padding: "14px 20px", textAlign: "center" }} className="desg-col-status">
                      {d.status ? (
                        <span style={{
                          background: d.status === "Active" ? "#e6f9f0" : "#f5f5f5",
                          color:      d.status === "Active" ? "#1a8a55" : "#888",
                          borderRadius: 20, padding: "3px 14px", fontSize: 13, fontWeight: 500,
                        }}>
                          {d.status}
                        </span>
                      ) : "—"}
                    </td>
                    <td style={{ padding: "14px 20px", textAlign: "center" }}>
                      {d.isQaFlag ? (
                        <span style={{ background: "#ede9fe", color: "#4c1d95", borderRadius: 20, padding: "3px 14px", fontSize: 13, fontWeight: 500 }}>
                          Tester
                        </span>
                      ) : (
                        <span style={{ background: "#dbeafe", color: "#1e3a8a", borderRadius: 20, padding: "3px 14px", fontSize: 13, fontWeight: 500 }}>
                          Developer
                        </span>
                      )}
                    </td>
                    <td style={{ padding: "14px 20px", textAlign: "center" }}>
                      <button
                        onClick={() => handleEdit(d)}
                        style={{ background: "none", border: "none", cursor: "pointer", color: BRAND }}
                        title="Edit"
                      >
                        <FiEdit2 size={17} />
                      </button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
      </div>

      {showModal && (
        <div
          onClick={(e) => { if (e.target === e.currentTarget) handleClose(); }}
          style={{
            position: "fixed", inset: 0,
            background: "rgba(0,0,0,0.45)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 1050,
          }}
        >
          <div style={{
            background: "#fff", borderRadius: 12,
            width: "100%", maxWidth: 480,
            margin: "0 16px",
            boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
            fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
            overflow: "hidden",
          }}>
            <div style={{ padding: "22px 24px 16px", borderBottom: "1px solid #f0f0f0", position: "relative" }}>
              <div style={{ fontSize: 17, fontWeight: 700, color: "#111827", marginBottom: 4 }}>
                {editId ? "Edit Designation" : "Add Designation"}
              </div>
              <div style={{ fontSize: 13, color: "#6b7280" }}>
                {editId ? "Update the designation details below." : "Fill in the details to add a new designation."}
              </div>
              <button
                onClick={handleClose}
                style={{ position: "absolute", top: 18, right: 20, background: "none", border: "none", cursor: "pointer", fontSize: 20, color: "#9ca3af", lineHeight: 1, padding: 0 }}
              >×</button>
            </div>

            <div style={{ padding: "22px 24px" }}>
              <div style={{ marginBottom: 18 }}>
                <label style={{ fontSize: 13, fontWeight: 600, color: "#374151", display: "block", marginBottom: 6 }}>
                  Designation Name <span style={{ color: "#dc2626" }}>*</span>
                </label>
                <GrayInput
                  placeholder="e.g. Jr. Front-end Developer"
                  value={designationName}
                  onChange={handleNameChange}
                  autoFocus
                />
                {nameError && <div style={{ fontSize: 12, color: "#dc2626", marginTop: 4 }}>{nameError}</div>}
              </div>

              <div style={{ marginBottom: 18 }}>
                <label style={{ fontSize: 13, fontWeight: 600, color: "#374151", display: "block", marginBottom: 6 }}>
                  Department
                </label>
                <GraySelect value={departmentId} onChange={(e) => setDepartmentId(e.target.value)}>
                  <option value="">Select department</option>
                  {departments.map((dept) => (
                    <option key={dept.id} value={String(dept.id)}>{dept.departmentName}</option>
                  ))}
                </GraySelect>
              </div>

              <div style={{ marginBottom: 22 }}>
                <label style={{ fontSize: 13, fontWeight: 600, color: "#374151", display: "block", marginBottom: 6 }}>
                  Level
                </label>
                <GraySelect value={level} onChange={(e) => setLevel(e.target.value)}>
                  <option value="">Select level</option>
                  {LEVELS.map((l) => <option key={l} value={l}>{l}</option>)}
                </GraySelect>
              </div>

              <div style={{ marginBottom: 18, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <label style={{ fontSize: 13, fontWeight: 600, color: "#374151", margin: 0 }}>
                  Active Status
                </label>
                <div
                  onClick={() => setStatus(status === "Active" ? "Inactive" : "Active")}
                  style={{
                    width: 34, height: 18, borderRadius: 9,
                    background: status === "Active" ? "#22c55e" : "#d1d5db",
                    cursor: "pointer", position: "relative",
                    transition: "background 0.25s ease", flexShrink: 0,
                  }}
                >
                  <div style={{
                    position: "absolute", top: 2,
                    left: status === "Active" ? 18 : 2,
                    width: 14, height: 14, borderRadius: "50%",
                    background: "#fff", transition: "left 0.25s ease",
                    boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
                  }} />
                </div>
              </div>

              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div>
                  <label style={{ fontSize: 13, fontWeight: 600, color: "#374151", margin: 0, display: "block", marginBottom: 2 }}>
                    QA / Tester Role
                  </label>
                  <div style={{ fontSize: 12, color: "#6b7280" }}>
                    Users with this designation appear in the Tester dropdown
                  </div>
                </div>
                <div
                  onClick={() => setIsQaFlag(!isQaFlag)}
                  style={{
                    width: 34, height: 18, borderRadius: 9,
                    background: isQaFlag ? "#6366f1" : "#d1d5db",
                    cursor: "pointer", position: "relative",
                    transition: "background 0.25s ease", flexShrink: 0,
                  }}
                >
                  <div style={{
                    position: "absolute", top: 2,
                    left: isQaFlag ? 18 : 2,
                    width: 14, height: 14, borderRadius: "50%",
                    background: "#fff", transition: "left 0.25s ease",
                    boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
                  }} />
                </div>
              </div>
            </div>

            <div style={{ padding: "16px 24px", borderTop: "1px solid #f0f0f0", display: "flex", justifyContent: "flex-end", gap: 10 }}>
              <button
                onClick={handleClose}
                disabled={submitting}
                style={{
                  padding: "9px 22px", background: "#fff",
                  border: "1px solid #d1d5db", borderRadius: 8,
                  fontSize: 14, fontWeight: 500, color: "#374151",
                  cursor: "pointer", fontFamily: "inherit",
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                disabled={submitting}
                style={{
                  padding: "9px 22px",
                  background: submitting ? "#7a9fd4" : BRAND,
                  border: "none", borderRadius: 8,
                  fontSize: 14, fontWeight: 600, color: "#fff",
                  cursor: submitting ? "not-allowed" : "pointer",
                  fontFamily: "inherit",
                }}
              >
                {submitting ? (editId ? "Updating…" : "Submitting…") : (editId ? "Update" : "Save")}
              </button>
            </div>
          </div>
        </div>
      )}

      <ToastContainer />
    </Container>
  );
};

const TH = { padding: "14px 20px", fontWeight: 600, color: "#444" };

export default Designation;